import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getOfferErrors, getOfferStatus, getSingleOffer } from '@store/reducers/offers/selectors';
import { createOfferAction } from '@store/actions/offers';
import { getSeriesOptions } from '@store/reducers/series/selectors';
import { getSeriesOptionsAction } from '@store/actions/series';
import { getTargets, getTypes } from '@store/reducers/agreements/selectors';
import { getTypesAndTargetsAction } from '@store/actions/agreements';
import Main from './Main';

const mapStateToProps = state => ({
  singleOffer: getSingleOffer(state),
  offerStatus: getOfferStatus(state),
  offerErrors: getOfferErrors(state),
  seriesOptions: getSeriesOptions(state),
  targets: getTargets(state),
  types: getTypes(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createOfferAction,
      getSeriesOptionsAction,
      getTypesAndTargetsAction,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
